import { render } from "./refundinfo.vue?vue&type=template&id=2004b2e4&scoped=true"
import script from "./refundinfo.vue?vue&type=script&lang=js"
export * from "./refundinfo.vue?vue&type=script&lang=js"

import "./refundinfo.vue?vue&type=style&index=0&id=2004b2e4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2004b2e4"]])

export default __exports__